import "@/App.css";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CalmPopup } from "@/components/CalmPopup";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ProfileProvider } from "@/context/ProfileContext";
import Home from "@/pages/Home";
import Gift from "@/pages/Gift";
import Admin from "@/pages/Admin";
import ProductDetail from "@/pages/ProductDetail";
import Lesson from "@/pages/Lesson";
import InfluencerPortal from "@/pages/InfluencerPortal";
import { captureRef } from "@/lib/ref";

captureRef();

function App() {
  return (
    <div className="App">
      <ProfileProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gift/:token" element={<Gift />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/prodotto/:id" element={<ProductDetail />} />

            <Route path="/scuola/:lessonId" element={<Lesson />} />
            <Route path="/influencer/:token" element={<InfluencerPortal />} />
          </Routes>
          <WhatsAppButton />
          <CalmPopup />
        </BrowserRouter>
        <Toaster position="bottom-center" offset={84} richColors />
      </ProfileProvider>
    </div>
  );
}

export default App;
